<template>
  <nav class="custom-navbar" id="main-navbar">
    <div class="nav-content">
      <ul class="nav-left">
        <li v-for="item in leftMenuItems" :key="item.text" class="nav-item">
          <router-link 
            v-if="item.type === 'link' && !item.path.startsWith('http')"
            :to="item.path"
            :class="item.class"
            @click="item.text === 'CV' ? downloadCV($event) : null"
          >
            {{ item.text }}
          </router-link>
          <a 
            v-else-if="item.type === 'link'"
            :href="item.path"
            :class="item.class"
            :title="item.title"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ item.text }}
          </a>
        </li>
      </ul>
      
      <ul class="nav-right">
        <li v-for="item in rightMenuItems" :key="item.text" class="nav-item">
          <a 
            :href="item.path"
            :title="item.title"
            target="_blank"
            rel="noopener noreferrer"
            class="social-link"
          >
            <i :class="item.iconClass"></i>
          </a>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'CustomNavbar',
  props: {
    leftMenuItems: {
      type: Array,
      default: () => []
    },
    rightMenuItems: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    downloadCV(event) {
      event.preventDefault();
      const cvPath = 'assets/Sebastiao_Carvalho_CV.pdf';
      const link = document.createElement('a');
      link.href = cvPath;
      link.download = 'Sebastiao_Carvalho_CV.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
</script>

<style scoped lang="scss">
.custom-navbar {
  background: linear-gradient(135deg, var(--background-card) 0%, #1e2328 100%);
  border-radius: 16px;
  box-shadow: var(--shadow-dark), var(--shadow-glow);
  border: 1px solid var(--border-color);
  backdrop-filter: blur(10px);
  margin: 0 20px;
  transition: all 0.3s ease;
  padding: 0 20px;
  
  &:hover {
    box-shadow: var(--shadow-hover), 0 0 30px rgba(0, 212, 255, 0.15);
    transform: translateY(-2px);
    border-color: var(--border-glow);
  }
}

.nav-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 5em;
  width: 100%;
}

.nav-left,
.nav-right {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.nav-left {
  justify-content: flex-start;
  flex: 1;
  /* Removed margin-left to allow items to align to the very left */
}

.nav-right {
  justify-content: flex-end;
  flex: 0 0 auto;
  /* Removed margin-right to allow items to align to the very right */
}

.nav-item a {
  font-size: 25px;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  position: relative;
  font-weight: 500;
  text-decoration: none;
  color: inherit;
  display: block;
  
  &:hover {
    background: linear-gradient(135deg, rgba(0, 212, 255, 0.1) 0%, rgba(91, 115, 255, 0.1) 100%);
    color: var(--text-bright);
    transform: translateY(-2px) scale(1.05);
    box-shadow: 0 4px 15px rgba(0, 212, 255, 0.2);
  }
  
  &::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 50%;
    transform: translateX(-50%) scaleX(0);
    width: 80%;
    height: 2px;
    background: var(--primary-gradient);
    border-radius: 1px;
    transition: transform 0.3s ease;
  }
  
  &:hover::after {
    transform: translateX(-50%) scaleX(1);
  }
}

.social-link {
  i {
    font-size: 1.2em;
    transition: all 0.3s ease;
    
    &.fa-github:hover {
      color: #333;
      text-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
    }
    
    &.fa-linkedin:hover {
      color: #0077b5;
      text-shadow: 0 0 10px rgba(0, 119, 181, 0.5);
    }
    
    &.fa-itch-io:hover {
      color: #fa5c5c;
      text-shadow: 0 0 10px rgba(250, 92, 92, 0.5);
    }
  }
}

// Mobile responsive
@media (max-width: 768px) {
  .custom-navbar {
    margin: 0 10px;
    padding: 10px;
  }
  
  .nav-content {
    flex-direction: column;
    height: auto;
    gap: 15px;
    padding: 10px 0;
  }
  
  .nav-left,
  .nav-right {
    justify-content: center;
    flex-wrap: wrap;
    gap: 10px;
    flex: none;
  }
  
  .nav-item a {
    font-size: 20px;
    padding: 0.4rem 0.8rem;
  }
  
  .social-link i {
    font-size: 1.1em;
  }
}

@media (max-width: 480px) {
  .nav-item a {
    font-size: 18px;
    padding: 0.3rem 0.6rem;
  }
  
  .social-link i {
    font-size: 1em;
  }
}
</style>